import React from "react";
import profileImage from "../assets/img/about.JPG";

const About = () => {
  return (
    <div className="m-8  px-4 py-10 text-gray-800">
      {/* Title */}
      <h1 className="text-5xl font-bold text-center mb-12 tracking-wide text-gray-900">
        About
      </h1>

      {/* Top Section with Image */}
      <div className="flex flex-col lg:flex-row items-center bg-gradient-to-r from-primary to-primary/80  via-white  p-10 rounded-2xl shadow-lg transition-all duration-500 hover:shadow-xl">
        <div className="lg:w-1/2 w-full flex justify-center mb-10 lg:mb-0">
          <img
            src={profileImage}
            alt="Sepi"
            className="w-80 h-80 md:w-96 md:h-96 object-cover rounded-full shadow-lg transform hover:scale-105 transition-transform duration-500"
          />
        </div>

        <div className="lg:w-1/2 w-full bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-4xl font-semibold mb-2 text-gray-900">
            Sepi Yar
          </h2>
          <p className="text-lg font-semibold mb-6  tracking-wide">
            COSMETIC TATTOO ARTIST | INTERNATIONAL TRAINER
          </p>

          <p className="text-base leading-7 mb-4 text-gray-700 lora-font">
            Meet SEPIYAR, a friendly and exceptionally talented beautician whose
            unique background and passion for beauty set her apart in the
            industry. Inspired by her mother’s deep roots in the beauty world,
            Sepi grew up surrounded by the transformative power of aesthetics,
            sparking a lifelong dedication to helping others feel beautiful and
            confident. As an award-winning painter, Sepi brings a keen eye for
            detail, color, and composition to every cosmetic tattoo she creates.
          </p>
          <p className="text-base leading-7 text-gray-700 lora-font">
            Her artistic journey has honed her ability to design bespoke
            treatments that are not only visually stunning but also perfectly
            tailored to enhance each client’s unique facial features. Whether
            you’re looking for subtle enhancements or bold statements, Sepi
            ensures that every piece is a personalized work of art.
          </p>
        </div>
      </div>

      {/* Professional Background & Expertise Section */}
      <div className="max-w-6xl mx-auto mt-16">
        <div className="bg-gradient-to-br from-white via-primary/20 to-secondary/30 rounded-3xl shadow-2xl p-12 border-l-8 border-primary relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-primary/20 rounded-full -mr-16 -mt-16"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-secondary/30 rounded-full -ml-12 -mb-12"></div>
          
          {/* Section Header */}
          <div className="text-center mb-10">
            <h3 className="text-3xl font-bold text-gray-900 mb-4 tracking-wide">
              Professional Excellence & Expertise
            </h3>
            <div className="w-24 h-1 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full"></div>
          </div>
          {/* Content Grid */}
          <div className="grid gap-8 text-left">
            {/* Artistic Excellence */}
            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-primary/20">
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-primary rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-base leading-7 text-gray-800">
                  <span className="font-semibold text-gray-900">Artistic Excellence:</span> A friendly and talented beautician whose unique background blends artistic excellence, teaching, and scientific expertise, Sepi has a lifelong passion for helping others feel beautiful.
                </p>
              </div>
            </div>

            {/* Scientific Background */}
            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-primary/20">
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-primary rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-base leading-7 text-gray-800">
                  <span className="font-semibold text-gray-900">Scientific Foundation:</span> As an award-winning painter, Sepi creates bespoke Cosmetic Tattoos known for their natural look and perfect blend with each client's features. She holds a <span className="font-medium text-gray-900">Master's degree in Developmental Biology</span> and has published <span className="font-medium text-gray-900">three ISI articles</span>, giving her a deep understanding of skin physiology and healing processes.
                </p>
              </div>
            </div>

            {/* Professional Certifications */}
            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-primary/20">
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-primary rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-base leading-7 text-gray-800">
                  <span className="font-semibold text-gray-900">Advanced Certifications:</span> With numerous international certificates in beauty, advanced facial treatments, and skin science, including specialised qualifications in <span className="font-medium text-gray-900">Microneedling, Plasma Therapy, and Professional Skin & Facial Treatments</span>, Sepi is equipped to treat a wide range of skin and hair concerns. She also holds a <span className="font-medium text-gray-900">Certification in Infection Prevention for Skin Penetration Treatments (HLTINF005)</span>, ensuring the highest standards of hygiene and safety.
                </p>
              </div>
            </div>

            {/* Educational Leadership */}
            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-primary/20">
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-primary rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-base leading-7 text-gray-800">
                  <span className="font-semibold text-gray-900">International Educator:</span> As an international educator, Sepi has trained many students who continue to benefit from her experience and artistry. Combining <span className="font-medium text-gray-900">artistic talent, scientific knowledge, and clinical precision</span>, she delivers stunning, natural-looking results that enhance each client's beauty with care and confidence.
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Accent */}
          <div className="text-center mt-10">
            <div className="inline-flex items-center space-x-2 bg-primary/30 px-6 py-3 rounded-full">
              <div className="w-2 h-2 bg-primary rounded-full"></div>
              <span className="text-sm font-medium text-gray-800 tracking-wide">EXCELLENCE • EXPERTISE • ARTISTRY</span>
              <div className="w-2 h-2 bg-primary rounded-full"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Existing Content Section (Made Prettier) */}
      <div className="max-w-5xl mx-auto mt-16 text-base leading-8 text-gray-700 space-y-6 bg-gradient-to-b  from-primary to-white p-10 rounded-2xl shadow-md hover:shadow-lg transition-all duration-500">
        <p>
          Adding to her artistic prowess, Sepi holds a master’s degree in
          developmental biology and has published three ISI articles in the
          field. This scientific expertise provides her with an in-depth
          understanding of skin physiology, healing processes, and the intricate
          relationship between skin structure and pigmentation. This knowledge
          allows her to approach each tattoo with precision, ensuring optimal
          results that complement the natural beauty of your skin.
        </p>

        <p>
          SEPIYAR is renowned for her cosmetic tattoos and beauty treatments,
          which are celebrated for looking incredibly natural! Her ability to
          seamlessly blend pigments to match skin tones and mimic natural
          features ensures that the results are subtle, realistic, and enhance
          her clients’ beauty without appearing artificial.
        </p>

        <p>
          Sepi is a distinguished educator in cosmetic tattoo and beauty,
          renowned for her international certifications and exceptional teaching
          talent. She imparts not only technical expertise but also a deep
          understanding of aesthetics and client relations to her students.
          Sepi’s dedication to excellence and her ability to inspire make her a
          leader in shaping future industry professionals.
        </p>

        <p>
          What truly sets Sepi apart is her unwavering commitment to your safety
          and well-being. She is certified in maintaining infection prevention
          for skin penetration treatments, known as HLTINF005. This
          certification ensures that she adheres to rigorous Safe and Effective
          Practice of Infection Control (SEPI) protocols, guaranteeing the
          highest standards of hygiene and safety during every cosmetic tattoo
          and all beauty/skin procedures. You can rest assured that your skin
          and health are meticulously protected throughout the entire process.
        </p>

        <p>
          Combining artistic talent, scientific knowledge, and top-notch safety
          practices, Sepi creates beautiful, personalized cosmetic tattoos that
          celebrate and enhance your natural beauty. Her friendly demeanor and
          professional approach make every client feel comfortable and confident
          in her capable hands. With Sepi, you’re not just getting a cosmetic
          tattoo—you’re receiving a masterpiece crafted with care, precision,
          and a genuine passion for making you look and feel your best.
        </p>
      </div>
    </div>
  );
};

export default About;
